import { useQuery } from '@tanstack/react-query'

import { systemApi } from '@/api/systemApi'

/**
 * Salud del backend (`GET /health`) — hook compartido para que Topbar y
 * cualquier página que ya la consultaba (Centro de Inteligencia, Pulso del
 * Municipio) usen la misma queryKey y no dupliquen la petición de red.
 * El dato crudo (`status`/`app`/`env`) nunca se muestra tal cual al
 * cliente — cada consumidor lo traduce a lenguaje de producto.
 */
export function useSystemHealth() {
  return useQuery({ queryKey: ['system', 'health'], queryFn: systemApi.health, refetchInterval: 30_000 })
}
